export default "__VITE_ASSET__CSaTatRu__"